module.exports = __webpack_public_path__ + "media/images/games/clash-royale/rectangle-4ef7aad01da91afdeebbbd0b974fa418.jpg";